import { PAGE_DESCRIPTION_MAX_LENGTH, PAGE_TITLE_MAX_LENGTH } from "@vote/shared/constants";
import type { PageMeta, PageMetaReader } from "../core/ports";

/** API契約の上限を超えるDOM文字列を切り詰め、永続的な400応答を防ぐ。 */
function truncateMeta(value: string, maximumLength: number, label: string): string {
  if (value.length <= maximumLength) {
    return value;
  }
  console.warn(`[vote-sdk] ${label}を${maximumLength}文字に切り詰めました`);
  return value.slice(0, maximumLength);
}

/**
 * ホスト記事のDOMからresolveに必要なメタデータだけを読み取るアダプタ。
 * canonicalを同一性の正とし、空の概要は送らずサーバの既存値を維持する。
 */
export class DomPageMetaReader implements PageMetaReader {
  public constructor(
    private readonly documentRef: Document = document,
    private readonly locationRef: Location = window.location,
    private readonly explicitPageTitle?: string,
  ) {}

  /** canonical優先URL・明示値優先の必須タイトル・任意概要をAPI入力形式で返す。 */
  public read(): PageMeta {
    // script属性の明示値だけを優先し、未指定時の判断はここでdocument.titleへ一度だけフォールバックする。
    const rawPageTitle = (this.explicitPageTitle ?? this.documentRef.title).trim();
    if (rawPageTitle === "") {
      throw new Error("記事タイトルがありません");
    }
    const pageTitle = truncateMeta(rawPageTitle, PAGE_TITLE_MAX_LENGTH, "記事タイトル");

    const canonicalUrl = this.documentRef
      .querySelector<HTMLLinkElement>('link[rel="canonical"]')
      ?.href.trim();
    const pageUrl =
      canonicalUrl === undefined || canonicalUrl === "" ? this.locationRef.href : canonicalUrl;
    const rawPageDescription = this.documentRef
      .querySelector<HTMLMetaElement>('meta[name="description"]')
      ?.content.trim();
    const pageDescription =
      rawPageDescription === undefined || rawPageDescription === ""
        ? undefined
        : truncateMeta(rawPageDescription, PAGE_DESCRIPTION_MAX_LENGTH, "記事概要");

    return {
      pageUrl,
      pageTitle,
      ...(pageDescription === undefined ? {} : { pageDescription }),
    };
  }
}
